import { State } from 'model/State';
import { getFromHamsClient } from 'util/mac/api/country/get';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';

export const countryTaasByName = (countryName: string, state: State) =>
  fetchWithParamValidation(
    ({ countryDisplayName }) =>
      getFromHamsClient(`/taas/findByDisplayName/${countryDisplayName}`, state),
    { countryDisplayName: encodeURIComponent(countryName) },
  );
